import { useMemo } from "react";

export type Message = {
  type: 'PORTAL_LOGGED_IN' | 'PORTAL_SIGNED_UP' | 'PORTAL_RESET_PASSWORD';
  payload: string;
}
const useEmbedded = () => {
  const isEmbedded = useMemo(() => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    []);

  const postMessageToParent = (message: Message) => {
    if (isEmbedded) {
      window.parent.postMessage(message, "*");
    }
  }

  return {
    isEmbedded,
    postMessageToParent
  };
};

export default useEmbedded;